import { Shop, User } from "@castiron/domain";

export const createOpenShopButtonClickedEvent = (shop: Shop, me: User) => ({
  shop: shop.id,
  shopName: shop.businessName,
  shopUrl: shop.websiteUrl,
  shopStatus: shop.status,
  user: me.uid,
}); 